export default __webpack_public_path__ + "static/media/dashboard_thumb.2e37fb7f.jpg";